import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { StripeIntegrationSettings } from '../../common';
import { CLASS_COMPONENT } from '../../common';
import { Text } from './text';

export function CancellationPolicyText() {
  const {
    integrationStripe: { cancellationPolicyText }
  } = useSettings<StripeIntegrationSettings>();

  return (
    <Text
      className={createReadableClass({
        component: CLASS_COMPONENT,
        element: 'cancellation-policy-text'
      })}
      textStyle={{ textAlign: 'left' }}
      dangerouslySetInnerHTML={{ __html: cancellationPolicyText }}
    />
  );
}
